import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import { notFoundAndNoPower, staticRoutes } from '/@/router/route';

import useUserStore from '/@/stores/module/user';
import { ElMessage } from 'element-plus';
import { removeUrlParams, seriazeParams, toLogin } from '/@/utils/index';
import { Session } from '/@/utils/storage';

/**
 * 创建一个可以被 Vue 应用程序使用的路由实例
 * @method createRouter(options: RouterOptions): Router
 * @link 参考：https://next.router.vuejs.org/zh/api/#createrouter
 */
export const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes: [...notFoundAndNoPower, ...staticRoutes],
});

// 路由加载前
router.beforeEach(async (to, from, next) => {
  const access_token = seriazeParams()?.access_token;
  const isBind = seriazeParams()?.app_id && seriazeParams()?.union_id && seriazeParams()?.open_id;
  if (access_token) {
    Session.set('access_token', access_token);
  }
  if (isBind && !access_token) {
    toLogin();
    return;
  }
  if (to.meta.requriedLogined) {
    const res: any = await useUserStore().getInfo();
    const { code, msg } = res;
    if (code === -1) {
      ElMessage({
        type: 'error',
        message: '你尚未登录，无法进入',
        onClose: () => {
          toLogin();
        },
      });
      return;
    }
    next();
  } else {
    next();
  }
});

// 路由加载后
router.afterEach((to, from, next) => {
  removeUrlParams(['access_token', 'refresh_token']);
});

// 导出路由
export default router;
